import { MARKUP_LEVEL, MARKUP_LEVEL_ABILITY } from '../constants/structure';

const percentFormatter = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });

export const formatPercent = value => `${percentFormatter.format(Number(value) || 0)} %`;

/** Компаунд-наценка, зеркало EntityMarkupService::getMarkupByPriceType: (1 + L1)(1 + L2) − 1. */
export const compoundMarkupPercent = (platform, agency) => ((1 + (Number(platform) || 0) / 100) * (1 + (Number(agency) || 0) / 100) - 1) * 100;

/** Уровни, которые актор видит: platform_percent отдаётся только admin. */
export const visibleMarkupLevels = markup => Object.values(MARKUP_LEVEL).filter(level => markup && level in markup);

export const canEditMarkupLevel = (partner, level) => Boolean(partner?.abilities?.[MARKUP_LEVEL_ABILITY[level]]);

export const canEditAnyMarkupLevel = partner => Object.values(MARKUP_LEVEL).some(level => canEditMarkupLevel(partner, level));

/** Кампания без переопределения уровня берёт наценку партнёра. */
export const effectiveMarkupPercent = (campaignMarkup, partnerMarkup, level) => campaignMarkup?.[level] ?? partnerMarkup?.[level] ?? null;

export const hasMarkupOverride = campaignMarkup => visibleMarkupLevels(campaignMarkup).some(level => campaignMarkup[level] != null);
